const appleAuth={}

export default appleAuth
export const AppleRequestResponse ={}